import { useEffect, useState, startTransition } from 'react'

const DEFAULT_DELAY_MS = 50

/**
 * After mount, becomes `true` following a short delay (default 50ms) so TanStack Query and
 * similar effects avoid Strict Mode double-mount cancellation.
 *
 * @param {number} [delayMs=50]
 * @param {unknown} [key] — If passed and falsy, stays `false`. If passed and changes, resets then goes true after delay (e.g. route `id`).
 */
export function useStableMount(delayMs = DEFAULT_DELAY_MS, key = undefined) {
  const [stable, setStable] = useState(false)
  useEffect(() => {
    if (key !== undefined && !key) {
      startTransition(() => setStable(false))
      return undefined
    }
    startTransition(() => setStable(false))
    const t = setTimeout(() => setStable(true), delayMs)
    return () => clearTimeout(t)
  }, [delayMs, key])
  return stable
}
